/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PriceRebateCalculationDto } from './PriceRebateCalculationDto';
export type PublicBookingWithPriceDetailsEntity = {
    id: string;
    createdAt: string;
    updatedAt: string;
    bookingStatus: PublicBookingWithPriceDetailsEntity.bookingStatus;
    organizationId: string;
    orderId: string | null;
    meetingId: string;
    /**
     * The date and time until the booking doesn't block a spot in the meeting anymore.
     */
    exclusiveUntil: string | null;
    guestId: string | null;
    customerId: string | null;
    multipassId: string | null;
    courseGroupId: string | null;
    multipassProductId: string | null;
    priceInMillsOverride: number | null;
    replaced: boolean;
    rebateCodeId: string;
    priceRebateCalculation: PriceRebateCalculationDto;
};
export namespace PublicBookingWithPriceDetailsEntity {
    export enum bookingStatus {
        RESERVED = 'RESERVED',
        CLAIMED = 'CLAIMED',
        FULFILLED = 'FULFILLED',
        REFUNDED = 'REFUNDED',
        CANCELLED = 'CANCELLED',
        CANCELLED_REFUNDED = 'CANCELLED_REFUNDED',
        WITHDRAWN = 'WITHDRAWN',
    }
}

